import ReactApexChart from 'react-apexcharts';
import React from 'react';
import { formatMonetary, isMobileDevice } from '../commons/utils';
import { ExPaper } from '../components/Paper';

export interface IProps {
    legendPosition?: any;
    removeLegend?: any;
    dataOffset?: any,
    height?: any;
    cellClick?: any;
    colors?: any;
    title?: any;
    monetary?: any;
}

interface IState {
    options?: any;
    series?: any;
    height?: any;
}

class PieChart extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            series: [],
            height: props.height,
            options: {
                labels: [],
                theme: !props.colors ? {
                    monochrome: {
                        enabled: true,
                        color: '#f68d2e',
                        shadeTo: 'dark',
                        shadeIntensity: 0.75
                    }
                } : {},
                colors: props.colors,
                plotOptions: {
                    pie: {
                        dataLabels: {
                            offset: (props.dataOffset !== undefined) ? props.dataOffset : - 5,
                            minAngleToShowLabel: 12
                        }
                    }
                },
                dataLabels: {
                    formatter(val: any, opts: any) {
                        const name = opts.w.globals.labels[opts.seriesIndex]
                        const value = opts.w.globals.series[opts.seriesIndex]
                        return [name, val.toFixed(1) + '% (' + (props.monetary ? formatMonetary(value) : value) + ')']
                    },
                    style: { colors: ['var(--chart-font-color)'] },
                    dropShadow: {
                        enabled: false
                    }
                    
                },
                legend: {
                    position: props.legendPosition ? props.legendPosition : 'bottom',
                    show: props.removeLegend ? false : true,
                    labels: {
                        colors: '#fff'
                    }
                },
                stroke: {
                    width: 0.35
                },
                title: {
                    text: props.title,
                    align: 'center',
                    style: {
                        color: '#fff',
                        fontWeight: 500,
                        fontFamily: "Montserrat, Segoe UI",
                    }
                }
            }
        }
    }


    setSeries = (series: any[] | []) => {
        this.setState({
            series
        });
    }

    setLabels = (labels: any[] | []) => {
        this.setState(prev => ({
            options: {
                ...prev.options,
                labels,
            }
        }));
    }

    setOptions = (dataPointSelection?: any) => {
        this.setState(prev => ({
            options: {
                ...prev.options,
                chart: {
                    ...prev.options.chart,
                    events: {
                        dataPointSelection
                    }
                },
                states: {
                    active: {
                        allowMultipleDataPointsSelection: true,
                    }
                }
            }
        }));
    }

    render() {
        return (
            <ExPaper style={{ height: isMobileDevice() ? '400px' : '100%' }}>
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    height={'100%'}
                    type="pie"
                    align="center"
                />
            </ExPaper >
        )
    }
}

export default PieChart;